module.exports = __webpack_public_path__ + "static/media/adventurer.6a51e00d.png";